import { AUTHED_ROUTES } from "routers/shared/util/consts";

export const canShowGlobalPreferenceTooltip = (pathname) => {
	const isDoubleTake = AUTHED_ROUTES.Doubletake.includes(pathname);

	return isDoubleTake;
};



// WEBPACK FOOTER //
// ./src/shared/components/GlobalPreferenceTooltip/helpers.js